
import React from "react";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { LayoutContext } from "../../Layouts/Admin/layoutcontext";
import { useEffect } from "react";

export default function UserGuide() {

    const {t, i18n} = useTranslation();
    const { setMenuTitle } = useContext(LayoutContext);
    useEffect(() => {
        setMenuTitle('Users Guide');
    },[]);
    
    return (
        // <div className="grid crud-demo">
        //     <div className="col-12">
                <div className="text-800 px-5">
                    <p className="text-4xl font-bold mb-0">Users</p>
                    <ul className="line-height-3-5">
                        <li>To create user, click on <span className="surface-300 p-2 border-round"><i className="pi pi-users pr-2"></i>All Users</span> and then <span className="p-2 border-round text-white" style={{background: '#689F38'}}><i className="pi pi-plus pr-2"></i>New</span></li>
                        <li>All fields are required except <strong>E-mail</strong></li>
                        <li>You can activate or deactivate a user by selecting a <strong>Status</strong></li>
                        <li>You can view list of users by accessing <span className="surface-300 p-2 border-round"><i className="pi pi-users pr-2"></i>All Users</span></li>
                    </ul>
                    <p className="text-4xl font-bold mb-0">Users Information</p>
                    <ul className="line-height-3-5">
                        <li><strong>Username</strong> has to be between 5 and 15 characters.</li>
                        <li><strong>Password</strong> has to be at least 8 characters.</li>
                        <li><strong>Email</strong> has to be a valid email format.</li>
                    </ul>
                    <p className="text-4xl font-bold mb-0">Updates of User Information/Password</p>
                    <ul className="line-height-3-5">
                        <li>A manager can reset user's password and update some other information</li>
                    </ul>
                    <p className="text-4xl font-bold mb-0">Changing a password</p>
                    <ul className="line-height-3-5">
                        <li>A user can change his/her own password by accessing <span className="surface-300 p-2 border-round"><i className="pi pi-wrench pr-2"></i>Preference</span></li>
                    </ul>
                    <p className="text-4xl font-bold mb-0">Close a session</p>
                    <ul className="line-height-3-5">
                        <li>After finishing a session, user can click on <span className="surface-300 p-2 border-round"><i className="pi pi-sign-out pr-2"></i>Logout</span></li>
                        <li>A session lasts for <span className="text-red font-bold">15 minutes</span>, counting from user's last activity.</li>
                    </ul>
                    <p className="text-4xl font-bold mb-2">Compatibility</p>
                    <span>The plat form has been successfully tested on:</span>
                    <ul className="line-height-3-5">
                        <li>The latest versions of <strong>Firefox</strong> and <strong>Chrome</strong> browsers</li>
                    </ul>
                    <p className="text-4xl font-bold mb-2">Contact us</p>
                    <span>If you have any inquires or comments, feel free to contact us at following address</span>
                    <div className="card bg-blue-100 border-round mt-2 p-3 py-2 text-cyan-700 text-sm" style={{lineHeight: '0.5'}}>
                        <p>Cambodia Securities Exchange Co., Ltd (CSX)</p>
                        <p>IT - Department</p>
                        <p>Email: it@csx.com.kh</p>
                        <p>CSX Building, St. Preah Mohaksat Treiyani Kossamak (St.106),</p>
                        <p>Sangkat Wat Phnom, Khan Daun Penh,Phnom Penh, Kingdom of Cambodia.</p>
                        <p>Tel: (855) 23 95 88 88 / 23 95 88 85</p>
                        <p>Fax: (855) 23 99 55 58</p>
                    </div>
                    
                </div>
        //     </div>
        // </div>
    )
}